import { render, staticRenderFns } from "./SlideOverHeader.vue?vue&type=template&id=4b9389ec&"
import script from "./SlideOverHeader.vue?vue&type=script&lang=js&"
export * from "./SlideOverHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports